import {Hydra} from '../generic/hydra';

import {PublicationListInterface} from './PublicationList';
import {FichierInterface} from './Fichier';
import {Publication as PublicationBaseInterface} from '../../interface/api/Publication';
import {PublicationTypeInterface} from "./PublicationType";

export interface PublicationInterface extends PublicationBaseInterface {}

export class Publication extends Hydra implements PublicationInterface {

    id?: number | null;

    publicationList?: PublicationListInterface | string | null;

    titre?: string | null;

    auteurs?: string | null;

    journal?: string | null;

    statut?: number | null;

    annee?: number | null;

    pmid?: number | null;

    doi?:string | null;

    /* Objet Fichier, avec un FichierType 'publication'
     */
    fichier?: FichierInterface | string | null;

    publicationType?:PublicationTypeInterface | string | null;

    position?: number | null = -1;


    constructor(options: PublicationInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
